/**
 * 빌드 시 결정되는 테넌트별 기능 플래그.
 *
 * namespace 문자열을 코드에서 직접 비교하면 테넌트가 늘 때마다 코드를 고쳐야 한다.
 * 플래그로 두면 env 파일 한 줄로 켜고 끌 수 있다(BO-2761).
 */

/**
 * 이용내역서 그룹 단위 일괄 다운로드.
 *
 * 꺼져 있으면 그룹 셀렉터를 감추고 일괄 모드로 전환되지 않는다 — 백엔드 접수도
 * 같은 취지로 막혀 있어, 화면만 열면 계정이 해제된 빈 화면이 된다.
 */
export const BULK_DOWNLOAD_ENABLED = process.env.VUE_APP_BULK_DOWNLOAD === 'true'
